import React from 'react';
import { SalesInvoiceFilters } from '../../../../app/models/SalesInvoice';

interface Props {
    filter: SalesInvoiceFilters;
    setFilter: (filter: SalesInvoiceFilters) => void;
    onSearch: () => void;
}

const SalesInvoiceFilter = ({ filter, setFilter, onSearch }: Props) => {
    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setFilter({ ...filter, [name]: value });
    };

    const handleSearch = () => {
        onSearch();
    };

    const handleClear = () => {
        setFilter({
            page: 1,
            per_page: 10,
            sort: 'id',
            order: 'desc',
            invoice_number: '',
            status: '',
            client_name: '',
            client_rut: '',
            folio: '',
            issue_date_from: '',
            issue_date_until: ''
        });
        onSearch();
    };

    return (
        <div className="row">
            <div className="row">
                <div className="col-md-auto">
                    <div className="mb-3">
                        <label className="font-size-10 mb-1" htmlFor="invoice_number">
                            N° Factura
                        </label>
                        <input
                            type="text"
                            id="invoice_number"
                            name="invoice_number"
                            className="form-control form-control-sm"
                            value={filter.invoice_number || ''}
                            onChange={handleInputChange}
                            placeholder="Buscar por número de factura"
                            title="Número de factura"
                        />
                    </div>
                </div>

                <div className="col-md-auto">
                    <div className="mb-3">
                        <label className="font-size-10 mb-1" htmlFor="status">
                            Estado
                        </label>
                        <select
                            id="estado"
                            name="status"
                            className="form-select form-select-sm"
                            value={filter.status || ''}
                            onChange={handleInputChange}
                        >
                            <option value="">Todos los estados</option>
                            <option value="BORRADOR">Borrador</option>
                            <option value="CONTABILIZADA">Contabilizada</option>
                            <option value="ANULADA">Anulada</option>
                        </select>
                    </div>
                </div>

                <div className="col-md-auto">
                    <div className="mb-3">
                        <label className="font-size-10 mb-1" htmlFor="client_rut">
                            RUT Cliente
                        </label>
                        <input
                            type="text"
                            id="client_rut"
                            name="client_rut"
                            className="form-control form-control-sm"
                            value={filter.client_rut || ''}
                            onChange={handleInputChange}
                            placeholder="Ej: 11.111.111-1"
                            title="RUT Cliente"
                        />
                    </div>
                </div>

                <div className="col-md-auto">
                    <div className="mb-3">
                        <label className="font-size-10 mb-1" htmlFor="client_name">
                            Cliente
                        </label>
                        <input
                            type="text"
                            id="client_name"
                            name="client_name"
                            className="form-control form-control-sm"
                            value={filter.client_name || ''}
                            onChange={handleInputChange}
                            placeholder="Nombre cliente"
                            title="Cliente"
                        />
                    </div>
                </div>

                <div className="col-md-auto">
                    <div className="mb-3">
                        <label className="font-size-10 mb-1" htmlFor="folio">
                            Folio
                        </label>
                        <input
                            type="text"
                            id="folio"
                            name="folio"
                            className="form-control form-control-sm"
                            value={filter.folio || ''}
                            onChange={handleInputChange}
                            placeholder="Folio factura"
                            title="Folio"
                        />
                    </div>
                </div>

                <div className="col-md-auto d-flex align-items-end">
                    <div className="mb-3">
                        <button
                            type="button"
                            className="btn btn-success btn-sm me-2"
                            onClick={handleSearch}
                        >
                            <i className="mdi mdi-magnify" /> Buscar
                        </button>
                        <button
                            type="button"
                            className="btn btn-secondary btn-sm"
                            onClick={handleClear}
                        >
                            <i className="mdi mdi-refresh" /> Limpiar
                        </button>
                    </div>
                </div>
            </div>

            {/* Segunda fila: fechas */}
            <div className="row">
                <div className="col-md-auto">
                    <div className="mb-3">
                        <label className="font-size-10 mb-1" htmlFor="issue_date_from">
                            Fecha emisión desde
                        </label>
                        <input
                            type="date"
                            id="issue_date_from"
                            name="issue_date_from"
                            className="form-control form-control-sm"
                            value={filter.issue_date_from || ''}
                            onChange={handleInputChange}
                        />
                    </div>
                </div>
                <div className="col-md-auto">
                    <div className="mb-3">
                        <label className="font-size-10 mb-1" htmlFor="issue_date_until">
                            Fecha emisión hasta
                        </label>
                        <input
                            type="date"
                            id="issue_date_until"
                            name="issue_date_until"
                            className="form-control form-control-sm"
                            value={filter.issue_date_until || ''}
                            onChange={handleInputChange}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SalesInvoiceFilter;

